import { createLink } from "@tanstack/react-router";

import { ButtonLink } from "./base";

/**
 * `ButtonLink` wired into TanStack Router: same typed `to`/`params`/`search`
 * props as `Link`, same look and press feedback as `Button`.
 */
export const ButtonRouterLink = createLink(ButtonLink);
